// PROD-7828: operator notes on payment-impacting edits; apis enforces joi min(3) too.
export const MIN_REASON_LENGTH = 3;
export const MAX_REASON_LENGTH = 200;

export function trim_reason(raw) {
  return (raw || '').trim();
}

export function is_valid_reason(raw) {
  return trim_reason(raw).length >= MIN_REASON_LENGTH;
}
